export const DataTypeActionContribution = Symbol.for('DataTypeActionContribution');
